import React, { useRef, useState, useEffect } from 'react';
import {
    Container,
    Box,
    Typography,
    Divider,
    TextField,
    Button,
    Avatar,
} from '@mui/material';
import Swal from 'sweetalert2';
import Axios from '../../../config/axios';
import { UrlConstant } from '../../../commom/UrlConstant';
import moment from 'moment';
import { getUserFromLocalStorage, formatTimestampToUserTimezone } from '../../../utils/utils';
import wolflogo from '../../../style/images/wolfpacklogo.png'
import gif from '../../../style/Gif/msgloading.gif'
import { useNavigate } from 'react-router-dom';
import Successpopup from '../SharedComponent/Successpopup';
import UpgradeNow from '../Popups/UpgradeNow';
import { formatPercentage } from '../../../utils/formatting';
import { usePriceFormatter } from '../../../hooks';


function AskWolf() {
    const user = getUserFromLocalStorage()
    const navigation = useNavigate();
    const navigate = useNavigate();
    const [question, setQuestion] = useState<any>('');
    const [qaList, setQaList] = useState<any>([]);
    const [loading, setLoading] = useState(false)
    const questionRefs = useRef({}); // Store refs for each question
    const textFieldRef = useRef<any>(null);
    const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
    const [msg, setmsg] = useState(''); // State for controlling popup visibility
    const [Success, setSuccess] = useState(false); // State for controlling popup visibility
    const [heading, setheading] = useState(''); // State for controlling popup visibility
    const [showUpgrade, setShowUpgrade] = useState(false); // State for controlling popup visibility
    const formatter = usePriceFormatter()


    const handleClose = () => {
        setShowUpgrade(false);
    }

    const onUpgradeNow = () => {
        setShowUpgrade(false);
        navigate('/premiumSubscription');
    }

    const handleChange = (event) => {
        setQuestion(event.target.value);
    };

    const saveToLocalStorage = (qaList) => {
        // Save local date in YYYY-MM-DD based on user's timezone
        const { date } = formatTimestampToUserTimezone(Date.now()); // MM/DD/YYYY
        const [month, day, year] = date.split('/');
        const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        const data = {
            date: isoDate,
            qaList,
        };
        localStorage.setItem('qaList', JSON.stringify(data));
    };

    const loadFromLocalStorage = () => {
        const savedData = localStorage.getItem('qaList');
        if (savedData) {
            const { date, qaList } = JSON.parse(savedData);
            const { date: todayDate } = formatTimestampToUserTimezone(Date.now());
            const [m, d, y] = todayDate.split('/');
            const today = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;

            if (date === today) {
                return qaList;
            } else {
                localStorage.removeItem('qaList');
            }
        }
        return [];
    };
    const onAskMrWolf = async (customQuestion?: string) => {
        setLoading(true);

        // If no custom question is provided, use the state question
        const finalQuestion = customQuestion || question;

        if (finalQuestion.trim() === '') {
            setheading("Error");
            setShowPopup(true);
            setmsg("Please enter a question");
            setLoading(false);
            return;
        }

        const questionId = Date.now();
        const currentTime = Date.now();

        setQaList((prevList) => {
            const updatedList = [
                ...prevList,
                { id: questionId, questionTime: currentTime, question: finalQuestion, answer: null },
            ];
            saveToLocalStorage(updatedList);
            return updatedList;
        });

        setQuestion(""); // Clear input if it's a manual question

        const data = { question: finalQuestion };

        try {
            const response = await Axios.post(UrlConstant.AskMrWolf.askMrWolf, data);
            const resData = response.data;

            const answer = resData;
            if (resData.status === true) {
                setQaList((prevList) => {
                    const updatedList = prevList.map((item) =>
                        item.id === questionId ? { ...item, answer } : item
                    );
                    saveToLocalStorage(updatedList);
                    return updatedList;
                });
            } else if (resData.status === false) {
                // setheading("Error");
                // setShowPopup(true);
                // setmsg(resData.message);
                setQaList((prevList) => {
                    const updatedList = prevList.map((item) =>
                        item.id === questionId ? { ...item, answer } : item
                    );
                    saveToLocalStorage(updatedList);
                    return updatedList;
                });
                // Swal.fire({
                //     title: 'Upgrade to Premium',
                //     text: `${resData.message} Or upgrade to premium to access this feature.`,
                //     icon: 'warning',
                //     showCancelButton: true,
                //     confirmButtonText: 'Get Premium',
                //     cancelButtonText: 'Cancel',
                // }).then((result) => {
                //     if (result.isConfirmed) {
                //         // Redirect to the /premium route
                //         navigate('/premiumSubscription');
                //     }
                // })
                if (resData?.statusCode === 426) {
                    setShowUpgrade(true);
                }
            } else {
                setheading("Error");
                setShowPopup(true);
                setmsg("Failed to fetch the answer");
            }
        } catch (error) {
            console.error("Error:", error);
            setheading("Error");
            setShowPopup(true);
            setmsg("An error occurred while fetching the answer");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const savedQaList = loadFromLocalStorage();
        setQaList(savedQaList);
    }, []);


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            onAskMrWolf();
        }
    };

    useEffect(() => {
        // Scroll to the latest question when qaList is updated
        if (qaList.length > 0) {
            const latestQuestionId = qaList[qaList.length - 1].id;
            const latestQuestionRef = questionRefs.current[latestQuestionId];
            if (latestQuestionRef) {
                latestQuestionRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [qaList]);

    useEffect(() => {
        // Keep TextField focused
        if (textFieldRef.current) {
            textFieldRef.current.focus();
        }
    }, [loading]);

    const clearChat = () => {
        setQaList([]);
        localStorage.removeItem('qaList');
    };


    const onClickInfo = (stock) => {
        if (stock?.isTradable) {
            navigation("/stockdetail", {
                state: {
                    symbol: stock?.ticker,
                    title: "Ask Mr. Wolf",
                    icon: stock?.branding?.icon_url ?? stock?.branding?.logo_url,
                },
            });
        } else {
            // Swal.fire("Currently we do not trade this stock in our system")
            setShowPopup(true)
            setmsg("Currently we do not trade this stock in our system")
        }


    }

    const closePopup = () => {
        setShowPopup(false); // Function to close the popup
    };
    return (
        <Container
            maxWidth={false}
            className="bg-color"
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100vh - 80px)',
                // overflow:'hidden',
                padding: '0px',
                marginBottom: '30px',
                width: '100%',
            }}
        >
            <Box padding="30px" height='calc(100% - 134px)'>
                <Box mb="18px" display='flex' alignItems='center' justifyContent='space-between'>
                    <Box>
                        <Box display="flex" gap="20px" alignItems="center">
                            <Typography className="text-white" fontSize="24px" fontWeight="800">
                                Your Personalized AI Assistant
                            </Typography>
                            <Button className="btn btn-primary" sx={{ padding: '3px 18px', fontWeight: '500' }}>
                                BETA
                            </Button>
                        </Box>
                        <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} >

                            <Typography className="text-secondary" fontSize="16px">
                                Intelligent Ideas, tailored insights, and smart discovery — powered by cutting-edge AI
                                to help you stay ahead.
                            </Typography>
                            {/* <Button onClick={clearChat} sx={{ textTransform: "none" }} >
                                Clear All
                            </Button> */}
                        </Box>
                    </Box>

                    <Box
                        // className="focus2"}
                        sx={{ height: '70px', alignItems: 'center', display: 'flex' }}
                    >
                        <Box className="gradient-border" sx={{ '&:hover::before, .transbtn': { background: 'transparent !important', backgroundColor: 'transparent !important' }, '&:hover  .gradiant-text': { WebkitTextFillColor: 'white !important' } }} >
                            <Button
                                onClick={clearChat}
                                className='transbtn'
                                sx={{
                                    padding: '0px 10px',
                                    color: "#f2674a",
                                    textDecoration: "none",
                                    backgroundColor: "#141414",

                                }}
                            >
                                <Typography className="gradiant-text" textTransform='none' >Clear all</Typography>
                            </Button>
                        </Box>
                    </Box>
                </Box>

                <Divider sx={{ mb: '30px', border: '1px solid #FFFFFF' }} />
                <Box
                    height="calc(100% - 90px)"
                    paddingRight="20px"
                    overflow="auto"
                    sx={{
                        '&::-webkit-scrollbar': {
                            width: '5px !important',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#FFFFFF33 !important',
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#555',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: '#FFFFFF1A !important',
                        },
                    }}
                >
                    {qaList?.length && qaList?.map((qa, i) => {
                        return (
                            <React.Fragment key={qa.id}>
                                {/* Question */}
                                <Box
                                    mb="20px"
                                    ref={(el) => (questionRefs.current[qa.id] = el)} // Assign ref for this question
                                >
                                    <Box className="usermsg">
                                        <Avatar
                                            src={user.profile_pic}
                                        />
                                        <Typography className="text-white" fontSize="16px">
                                            {qa.question}
                                        </Typography>
                                    </Box>
                                    <Typography className="text-white" mt="10px" textAlign="end" fontSize="12px">
                                        {(() => {
                                            const { date, time } = formatTimestampToUserTimezone(qa.questionTime);
                                            return <>{date} | <span className="text-blue">{time}</span></>;
                                        })()}
                                    </Typography>
                                </Box>
                                {/* Answer */}
                                <Box mb="20px">
                                    <Box className="wolfreply" bgcolor={qa?.answer ? '' : 'transparent'}>
                                        <Box display="flex" mb="10px" gap="10px" width='fit-content' alignItems="center">
                                            <Avatar src={wolflogo}></Avatar>
                                            <Typography className="text-white" width='fit-content' fontSize="16px" >
                                                {qa?.answer ? 'Response from Mr. Wolf' : <img src={gif} alt="" height='28px' />}
                                            </Typography>
                                        </Box>
                                        {Array.isArray(qa?.answer?.data) && qa?.answer?.data?.length > 0 ?
                                            qa.answer.data.map((stock, stockIndex) => (
                                                <Box key={stockIndex} ml="56px">
                                                    <Box display="flex" gap="10px" alignItems="center" justifyContent={"space-between"}>
                                                        <Box display="flex" alignItems={"center"} gap={"10px"}>
                                                            <Avatar
                                                                alt={stock?.name}
                                                                src={stock?.branding?.icon_url ?? stock?.branding?.logo_url}
                                                            >
                                                                {(!stock?.branding?.icon_url && !stock?.branding?.logo_url && stock?.name) &&
                                                                    stock.name.slice(0, 2).toUpperCase()
                                                                }
                                                            </Avatar>
                                                            <Typography className="text-white" fontWeight="800">
                                                                {stock?.name}
                                                            </Typography>
                                                        </Box>
                                                        <Button
                                                            className="btn-blue btn"
                                                            sx={{ padding: '5px 35px' }}
                                                            onClick={() => { onClickInfo(stock) }}
                                                        >
                                                            Info
                                                        </Button>
                                                    </Box>
                                                    <Typography
                                                        ml="50px"
                                                        className="text-white"
                                                        fontSize="16px"
                                                    >
                                                        <span>
                                                            Symbol: {stock.ticker} &nbsp; | &nbsp;
                                                        </span>

                                                        <span>
                                                            Price: {formatter.display(stock.price)}
                                                        </span>

                                                        &nbsp; | &nbsp;

                                                        Change:
                                                        <span
                                                            className={
                                                                stock.change === 0
                                                                    ? ""
                                                                    : stock.change > 0
                                                                        ? "text-green"
                                                                        : "text-red"
                                                            }
                                                        >
                                                            {" "}
                                                            {formatter.display(stock.change, {
                                                                showSign: true,
                                                            })}
                                                        </span>

                                                        &nbsp; | &nbsp;

                                                        Change Percentage:
                                                        <span
                                                            className={
                                                                stock.change === 0
                                                                    ? ""
                                                                    : stock.change > 0
                                                                        ? "text-green"
                                                                        : "text-red"
                                                            }
                                                        >
                                                            {" "}
                                                            {formatPercentage(stock.changePercentage, {
                                                                showSign: true,
                                                            })}
                                                        </span>
                                                    </Typography>
                                                    <Divider sx={{ mt: '20px', border: '1px solid #FFFFFF1A' }} />
                                                </Box>
                                            ))
                                            :
                                            <Typography mt={"20px"} color='red' >
                                                {qa?.answer?.message}
                                            </Typography>
                                        }
                                    </Box>
                                    {qa?.answer ? <Typography className="text-white" mt="10px" fontSize="12px">
                                        {(() => {
                                            const { date, time } = formatTimestampToUserTimezone(qa?.answer?.timestamp);
                                            return <>{date} | <span className="text-blue">{time}</span></>;
                                        })()}
                                    </Typography> : ''}

                                </Box>
                            </React.Fragment>
                        )
                    })}
                </Box>
            </Box>

            <Box
                padding="0px 20px 20px 20px "
                bgcolor='#4A7AF21A'
                position='sticky'
                height='fit-content'
                bottom={0}
                sx={{ borderTop: '1px solid #FFFFFF1A', borderBottom: '1px solid #FFFFFF1A' }}
            >
                <Box display='flex' my='15px' alignItems='center' justifyContent='flex-start'>
                    <Typography color='#F2674A'>Hot Questions:</Typography>
                    <Box className="buttongroup" overflow='auto' gap='20px' display='flex' ml={"10px"}>
                        {/* <Button className="btn btn-green" sx={{ whiteSpace: 'nowrap !important', width: 'auto !important' }} onClick={() => onAskMrWolf("Top 3 ETF Dividend Yield")}>
                            Top 3 ETF Dividend Yield
                        </Button> */}

                        <Button className="btn btn-green" sx={{ textWrap: 'nowrap' }} onClick={() => onAskMrWolf("Top 3 Performance (YTD)")}>
                            Top 3 Performance (YTD)
                        </Button>

                        <Button className="btn btn-green" sx={{ textWrap: 'nowrap' }} onClick={() => onAskMrWolf("Bottom 3 Performance (YTD)")}>
                            Bottom 3 Performance (YTD)
                        </Button>

                        <Button className="btn btn-green" sx={{ textWrap: 'nowrap' }} onClick={() => onAskMrWolf("Top 3 Stocks Dividend Yield")}>
                            Top 3 Stocks Dividend Yield
                        </Button>

                        <Button className="btn btn-green" sx={{ textWrap: 'nowrap' }} onClick={() => onAskMrWolf("Top 3 Short Interest")}>
                            Top 3 Short Interest
                        </Button>

                        <Button className="btn btn-green" sx={{ textWrap: 'nowrap' }} onClick={() => onAskMrWolf("Top 3 Performance (YTD) & Dividend Yield")}>
                            Top 3 Performance (YTD) & Dividend Yield
                        </Button>

                    </Box>
                </Box>
                <TextField
                    placeholder="Ask Mr.Wolf"
                    sx={{
                        width: '100% !important',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '10px !important',
                            borderColor: ' #FFFFFF1A !important',
                            backgroundColor: '#FFFFFF1A !important',
                        },
                        '& .MuiOutlinedInput-input': {
                            height: '64px !important',
                            color: 'white !important',
                        },
                        '& .Mui-focused MuiOutlinedInput-notchedOutline': {
                            border: '1px solid  #FFFFFF33 !important',
                        },
                    }}
                    slotProps={{
                        input: {
                            startAdornment:
                                <div style={{ borderRight: '1px solid #FFFFFF33', height: '100%', marginRight: '10px' }}>
                                    <svg width="22" style={{ marginRight: "10px" }} height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.67506 19.957C6.65292 20.1045 6.64186 20.2532 6.64195 20.4022C6.64195 22.3898 8.59297 24.0004 11 24.0004C13.407 24.0004 15.3583 22.3893 15.3583 20.4022C15.3583 20.2533 15.3472 20.1045 15.3252 19.957C14.896 21.5911 13.7962 22.7538 12.5071 22.7538C11.958 22.7538 11.4434 22.5427 11 22.1746C10.5569 22.5427 10.0422 22.7538 9.49324 22.7538C8.20409 22.7538 7.10428 21.5911 6.67506 19.957Z" fill="url(#paint0_linear_2903_9061)" />
                                        <path d="M19.1216 5.31298C19.1018 5.90029 19.011 6.48367 18.8507 7.05206C18.8011 7.22731 18.7863 7.14444 18.7905 7.08005C18.8372 6.36729 18.6199 5.69568 18.2752 5.13129C18.1599 5.45985 17.9925 5.77056 17.7786 6.05318C17.801 5.64359 17.7432 5.23364 17.6082 4.84321C17.63 4.92722 17.6392 5.0136 17.6356 5.09993C17.6188 5.58481 17.2082 5.96443 16.7188 5.94736C16.2294 5.93028 15.8459 5.5235 15.8637 5.03862C15.8739 4.74803 16.0142 4.47871 16.2508 4.34294C17.1507 3.83181 17.9655 3.20124 18.6695 2.47116C19.0015 3.38541 19.1544 4.34765 19.121 5.31214L19.1216 5.31298ZM6.1366 5.03722C6.15375 5.5221 5.77089 5.92916 5.28178 5.94596C4.79267 5.96275 4.38242 5.58425 4.36647 5.09937C4.36317 5.01303 4.37248 4.92667 4.39416 4.84265C4.25894 5.23303 4.20111 5.64301 4.2235 6.05262C4.00938 5.76999 3.84169 5.45929 3.72596 5.13073C3.38103 5.69512 3.16401 6.36673 3.21067 7.07949C3.21488 7.14444 3.20013 7.22731 3.15047 7.0515C2.99024 6.48311 2.89937 5.89973 2.87958 5.31242C2.84631 4.34794 2.99923 3.38572 3.33106 2.47144C4.03552 3.20131 4.85077 3.8316 5.75103 4.34238C5.987 4.47787 6.12756 4.74747 6.1378 5.03806L6.1366 5.03722ZM19.7314 7.45939C19.949 6.71627 20.0585 5.94935 20.0568 5.17916C20.0568 3.22256 19.3712 1.42469 18.2208 0C16.7742 2.45576 14.0824 4.11337 11 4.11337C7.91756 4.11337 5.2261 2.45576 3.77954 0C2.62975 1.42469 1.9435 3.22256 1.9435 5.17916C1.94194 5.94936 2.05147 6.71628 2.26917 7.45939C1.07694 8.30737 0.234773 9.61504 0 11.1234C0.450757 10.9892 0.918452 10.9105 1.39118 10.8891C0.767631 11.8126 0.439321 12.882 0.444564 13.9725C0.444564 15.4244 1.00591 16.7463 1.91641 17.7144C2.1575 17.27 2.44096 16.8466 2.76339 16.4493C2.9583 17.6899 3.44503 18.8752 4.18888 19.9207C4.31 20.0993 4.44216 20.2712 4.58469 20.4356C4.83864 19.6559 5.27497 18.9382 5.86239 18.3339C5.53539 18.4037 5.20155 18.4421 4.86611 18.4485C4.38686 17.6058 4.13785 16.6663 4.14103 15.713C4.14036 15.1268 4.23359 14.5438 4.41764 13.9832C3.68502 14.1391 2.99561 14.436 2.39378 14.8547C2.35265 14.5799 2.33204 14.3028 2.33207 14.0254C2.33207 10.9552 4.29604 9.49018 6.58387 9.49018C11.109 9.49018 9.65818 16.0571 8.9632 18.1595C10.2724 17.6816 11.7276 17.6816 13.0368 18.1595C12.3427 16.0568 10.8913 9.4899 15.4164 9.4899C17.704 9.4899 19.6682 10.9549 19.6682 14.0252C19.6683 14.3026 19.6476 14.5796 19.6065 14.8544C19.0047 14.4357 18.3153 14.1388 17.5827 13.9829C17.7667 14.5435 17.8599 15.1265 17.8593 15.7127C17.8623 16.6659 17.6132 17.6051 17.1339 18.4476C16.7985 18.4413 16.4646 18.4029 16.1376 18.3331C16.725 18.9374 17.1614 19.6551 17.4153 20.4347C17.5576 20.2704 17.6897 20.0986 17.8108 19.9202C18.5547 18.8746 19.0416 17.6893 19.2366 16.4487C19.559 16.846 19.8425 17.2694 20.0836 17.7138C20.9941 16.7458 21.5554 15.4238 21.5554 13.972C21.5605 12.8815 21.2322 11.8121 20.6088 10.8886C21.0816 10.9099 21.5492 10.9887 22 11.1229C21.7652 9.61392 20.9228 8.30681 19.7308 7.45883" fill="url(#paint1_linear_2903_9061)" />
                                        <path d="M7.33334 11.7645C7.33334 11.7645 7.41129 11.823 7.49106 11.8849C7.33244 12.3208 7.02031 12.5568 6.55799 12.5568C5.93434 12.5568 5.59482 12.1089 5.66976 11.521C5.67628 11.4447 5.69526 11.3699 5.72605 11.299C5.7727 11.2965 5.81966 11.2951 5.86661 11.2951C5.96197 11.2951 6.05725 11.3003 6.15195 11.3107C6.15436 11.3161 6.15556 11.3194 6.15556 11.3194C5.88738 11.8326 6.39003 12.2083 6.39003 12.2083C6.39003 12.2083 6.61277 12.1632 6.8963 11.9843C7.05883 11.8978 7.11542 11.6604 7.33274 11.7659L7.33334 11.7645ZM7.68399 11.7603C6.88998 11.0045 5.55358 10.8496 4.58379 11.395L4.56453 11.4054C4.70376 11.8179 4.96075 12.1876 5.3081 12.4751C5.65545 12.7625 6.08015 12.9569 6.53692 13.0375L6.53541 13.0425C7.26832 13.1397 7.95007 13.5604 8.34707 14.1064C8.60472 13.2892 8.34196 12.3524 7.6849 11.7598" fill="url(#paint2_linear_2903_9061)" />
                                        <path d="M14.6667 11.7645C14.6667 11.7645 14.5887 11.823 14.5092 11.8849C14.6679 12.3208 14.98 12.5568 15.4423 12.5568C16.0657 12.5568 16.4055 12.1089 16.3305 11.521C16.324 11.4447 16.305 11.3699 16.2742 11.299C16.2276 11.2965 16.1806 11.2951 16.1334 11.2951C16.0381 11.2951 15.9429 11.3003 15.8483 11.3107L15.8444 11.3194C16.1129 11.8326 15.6103 12.2083 15.6103 12.2083C15.6103 12.2083 15.3875 12.1632 15.104 11.9843C14.9415 11.8978 14.8846 11.6604 14.6673 11.7659L14.6667 11.7645ZM14.3163 11.7603C15.11 11.0045 16.4467 10.8496 17.4165 11.395L17.4355 11.4054C17.2963 11.8179 17.0394 12.1877 16.6921 12.4751C16.3448 12.7626 15.9201 12.9569 15.4634 13.0375V13.0425C14.7305 13.1397 14.0487 13.5604 13.652 14.1064C13.3944 13.2892 13.6571 12.3524 14.3142 11.7598" fill="url(#paint3_linear_2903_9061)" />
                                        <path d="M12.7719 20.0023C12.7719 19.2924 11.9788 18.9727 11 18.9727C10.0212 18.9727 9.22806 19.2924 9.22806 20.0023C9.22833 20.0473 9.23164 20.0922 9.23799 20.1367C9.32829 20.7526 10.0561 21.046 11 21.4682C11.9439 21.046 12.6711 20.7526 12.7623 20.1367C12.7685 20.0921 12.7718 20.0473 12.7719 20.0023Z" fill="url(#paint4_linear_2903_9061)" />
                                        <path d="M6.67506 19.957C6.65292 20.1045 6.64186 20.2532 6.64195 20.4022C6.64195 22.3898 8.59297 24.0004 11 24.0004C13.407 24.0004 15.3583 22.3893 15.3583 20.4022C15.3583 20.2533 15.3472 20.1045 15.3252 19.957C14.896 21.5911 13.7962 22.7538 12.5071 22.7538C11.958 22.7538 11.4434 22.5427 11 22.1746C10.5569 22.5427 10.0422 22.7538 9.49324 22.7538C8.20409 22.7538 7.10428 21.5911 6.67506 19.957Z" fill="url(#paint5_linear_2903_9061)" />
                                        <path d="M19.1216 5.31298C19.1018 5.90029 19.011 6.48367 18.8507 7.05206C18.8011 7.22731 18.7863 7.14444 18.7905 7.08005C18.8372 6.36729 18.6199 5.69568 18.2752 5.13129C18.1599 5.45985 17.9925 5.77056 17.7786 6.05318C17.801 5.64359 17.7432 5.23364 17.6082 4.84321C17.63 4.92722 17.6392 5.0136 17.6356 5.09993C17.6188 5.58481 17.2082 5.96443 16.7188 5.94736C16.2294 5.93028 15.8459 5.5235 15.8637 5.03862C15.8739 4.74803 16.0142 4.47871 16.2508 4.34294C17.1507 3.83181 17.9655 3.20124 18.6695 2.47116C19.0015 3.38541 19.1544 4.34765 19.121 5.31214L19.1216 5.31298ZM6.1366 5.03722C6.15375 5.5221 5.77089 5.92916 5.28178 5.94596C4.79267 5.96275 4.38242 5.58425 4.36647 5.09937C4.36317 5.01303 4.37248 4.92667 4.39416 4.84265C4.25894 5.23303 4.20111 5.64301 4.2235 6.05262C4.00938 5.76999 3.84169 5.45929 3.72596 5.13073C3.38103 5.69512 3.16401 6.36673 3.21067 7.07949C3.21488 7.14444 3.20013 7.22731 3.15047 7.0515C2.99024 6.48311 2.89937 5.89973 2.87958 5.31242C2.84631 4.34794 2.99923 3.38572 3.33106 2.47144C4.03552 3.20131 4.85077 3.8316 5.75103 4.34238C5.987 4.47787 6.12756 4.74747 6.1378 5.03806L6.1366 5.03722ZM19.7314 7.45939C19.949 6.71627 20.0585 5.94935 20.0568 5.17916C20.0568 3.22256 19.3712 1.42469 18.2208 0C16.7742 2.45576 14.0824 4.11337 11 4.11337C7.91756 4.11337 5.2261 2.45576 3.77954 0C2.62975 1.42469 1.9435 3.22256 1.9435 5.17916C1.94194 5.94936 2.05147 6.71628 2.26917 7.45939C1.07694 8.30737 0.234773 9.61504 0 11.1234C0.450757 10.9892 0.918452 10.9105 1.39118 10.8891C0.767631 11.8126 0.439321 12.882 0.444564 13.9725C0.444564 15.4244 1.00591 16.7463 1.91641 17.7144C2.1575 17.27 2.44096 16.8466 2.76339 16.4493C2.9583 17.6899 3.44503 18.8752 4.18888 19.9207C4.31 20.0993 4.44216 20.2712 4.58469 20.4356C4.83864 19.6559 5.27497 18.9382 5.86239 18.3339C5.53539 18.4037 5.20155 18.4421 4.86611 18.4485C4.38686 17.6058 4.13785 16.6663 4.14103 15.713C4.14036 15.1268 4.23359 14.5438 4.41764 13.9832C3.68502 14.1391 2.99561 14.436 2.39378 14.8547C2.35265 14.5799 2.33204 14.3028 2.33207 14.0254C2.33207 10.9552 4.29604 9.49018 6.58387 9.49018C11.109 9.49018 9.65818 16.0571 8.9632 18.1595C10.2724 17.6816 11.7276 17.6816 13.0368 18.1595C12.3427 16.0568 10.8913 9.4899 15.4164 9.4899C17.704 9.4899 19.6682 10.9549 19.6682 14.0252C19.6683 14.3026 19.6476 14.5796 19.6065 14.8544C19.0047 14.4357 18.3153 14.1388 17.5827 13.9829C17.7667 14.5435 17.8599 15.1265 17.8593 15.7127C17.8623 16.6659 17.6132 17.6051 17.1339 18.4476C16.7985 18.4413 16.4646 18.4029 16.1376 18.3331C16.725 18.9374 17.1614 19.6551 17.4153 20.4347C17.5576 20.2704 17.6897 20.0986 17.8108 19.9202C18.5547 18.8746 19.0416 17.6893 19.2366 16.4487C19.559 16.846 19.8425 17.2694 20.0836 17.7138C20.9941 16.7458 21.5554 15.4238 21.5554 13.972C21.5605 12.8815 21.2322 11.8121 20.6088 10.8886C21.0816 10.9099 21.5492 10.9887 22 11.1229C21.7652 9.61392 20.9228 8.30681 19.7308 7.45883" fill="url(#paint6_linear_2903_9061)" />
                                        <path d="M7.33334 11.7645C7.33334 11.7645 7.41129 11.823 7.49106 11.8849C7.33244 12.3208 7.02031 12.5568 6.55799 12.5568C5.93434 12.5568 5.59482 12.1089 5.66976 11.521C5.67628 11.4447 5.69526 11.3699 5.72605 11.299C5.7727 11.2965 5.81966 11.2951 5.86661 11.2951C5.96197 11.2951 6.05725 11.3003 6.15195 11.3107C6.15436 11.3161 6.15556 11.3194 6.15556 11.3194C5.88738 11.8326 6.39003 12.2083 6.39003 12.2083C6.39003 12.2083 6.61277 12.1632 6.8963 11.9843C7.05883 11.8978 7.11542 11.6604 7.33274 11.7659L7.33334 11.7645ZM7.68399 11.7603C6.88998 11.0045 5.55358 10.8496 4.58379 11.395L4.56453 11.4054C4.70376 11.8179 4.96075 12.1876 5.3081 12.4751C5.65545 12.7625 6.08015 12.9569 6.53692 13.0375L6.53541 13.0425C7.26832 13.1397 7.95007 13.5604 8.34707 14.1064C8.60472 13.2892 8.34196 12.3524 7.6849 11.7598" fill="url(#paint7_linear_2903_9061)" />
                                        <path d="M14.6667 11.7645C14.6667 11.7645 14.5887 11.823 14.5092 11.8849C14.6679 12.3208 14.98 12.5568 15.4423 12.5568C16.0657 12.5568 16.4055 12.1089 16.3305 11.521C16.324 11.4447 16.305 11.3699 16.2742 11.299C16.2276 11.2965 16.1806 11.2951 16.1334 11.2951C16.0381 11.2951 15.9429 11.3003 15.8483 11.3107L15.8444 11.3194C16.1129 11.8326 15.6103 12.2083 15.6103 12.2083C15.6103 12.2083 15.3875 12.1632 15.104 11.9843C14.9415 11.8978 14.8846 11.6604 14.6673 11.7659L14.6667 11.7645ZM14.3163 11.7603C15.11 11.0045 16.4467 10.8496 17.4165 11.395L17.4355 11.4054C17.2963 11.8179 17.0394 12.1877 16.6921 12.4751C16.3448 12.7626 15.9201 12.9569 15.4634 13.0375V13.0425C14.7305 13.1397 14.0487 13.5604 13.652 14.1064C13.3944 13.2892 13.6571 12.3524 14.3142 11.7598" fill="url(#paint8_linear_2903_9061)" />
                                        <path d="M12.7719 20.0023C12.7719 19.2924 11.9788 18.9727 11 18.9727C10.0212 18.9727 9.22806 19.2924 9.22806 20.0023C9.22833 20.0473 9.23164 20.0922 9.23799 20.1367C9.32829 20.7526 10.0561 21.046 11 21.4682C11.9439 21.046 12.6711 20.7526 12.7623 20.1367C12.7685 20.0921 12.7718 20.0473 12.7719 20.0023Z" fill="url(#paint9_linear_2903_9061)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_2903_9061" x1="6.09718" y1="19.957" x2="6.20736" y2="24.2361" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_2903_9061" x1="-1.375" y1="-3.69987e-09" x2="-0.262095" y2="21.5835" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint2_linear_2903_9061" x1="4.32202" y1="11.0703" x2="4.4614" y2="14.2794" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint3_linear_2903_9061" x1="13.3118" y1="11.0703" x2="13.4511" y2="14.2794" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint4_linear_2903_9061" x1="9.00657" y1="18.9727" x2="9.10971" y2="21.6113" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint5_linear_2903_9061" x1="6.09718" y1="19.957" x2="6.20736" y2="24.2361" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint6_linear_2903_9061" x1="-1.375" y1="-3.69987e-09" x2="-0.262095" y2="21.5835" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint7_linear_2903_9061" x1="4.32202" y1="11.0703" x2="4.4614" y2="14.2794" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint8_linear_2903_9061" x1="13.3118" y1="11.0703" x2="13.4511" y2="14.2794" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                            <linearGradient id="paint9_linear_2903_9061" x1="9.00657" y1="18.9727" x2="9.10971" y2="21.6113" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#F2674A" />
                                                <stop offset="1" stop-color="#FCB118" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>,
                            endAdornment:
                                <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => { onAskMrWolf() }}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.51002 4.22867L18.07 8.50867C21.91 10.4287 21.91 13.5687 18.07 15.4887L9.51002 19.7687C3.75002 22.6487 1.40002 20.2887 4.28002 14.5387L5.15002 12.8087C5.37002 12.3687 5.37002 11.6387 5.15002 11.1987L4.28002 9.45867C1.40002 3.70867 3.76002 1.34867 9.51002 4.22867Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.43994 12H10.8399" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>

                        },
                    }}
                    inputRef={textFieldRef}
                    disabled={loading}
                    value={question}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                />
            </Box>
            {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}
            {/* {showUpgrade ? <UpgradeNow onClose={handleClose} confirm_process={onUpgradeNow}/> : null} */}

        </Container>
    );
}

export default AskWolf;
